import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

export default function ForbiddenScreen({
  title = '403 — Access denied',
  message = "You don't have permission to view this page.",
  hint = 'Use the sidebar to return to a section you can access, or contact HR if you believe this is a mistake.',
}) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 96px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          maxWidth: 520,
          width: '100%',
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          textAlign: 'center',
          borderColor: alpha(theme.palette.warning.main, 0.32),
          background:
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.background.paper, 0.7)
              : theme.palette.background.paper,
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: alpha(theme.palette.warning.main, 0.18),
              color: theme.palette.warning.main,
            }}
          >
            <LockOutlinedIcon fontSize="medium" />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {hint}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.2} sx={{ pt: 0.5 }}>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Go back
            </Button>
            <Button variant="contained" onClick={() => navigate('/')}>
              Go to home
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
